// extracted by mini-css-extract-plugin
export default {"wrapper":"_18u46","container":"_2wAR5","isCentered":"EVqiw","alwaysLtr":"z74qT","alwaysHorizontal":"_34h7O","buttonWrapper":"E-wDf","button":"_1wsAI"};